export default {"src":"/_next/static/media/UpArrowRed.c8383353.svg","height":8,"width":12,"blurWidth":0,"blurHeight":0};